import { components } from "@certn/api/generated-schemas/applicant-portal";

export const FITNESS_PROPRIETY_KEY = "fitness_propriety_1";

export type FitnessProprietyTemplate =
  components["schemas"]["FitnessProprietyTemplate"];

export type FitnessProprietyAnswerType = Record<
  string,
  string | number | undefined | null
>;

export type FitnessProprietyFormType = {
  templateId: string;
  name: string;
  isCurrent: boolean;
  claims: components["schemas"]["FitnessProprietyTemplateInputClaim"][];
  answers: FitnessProprietyAnswerType;
  conditions?: components["schemas"]["FitnessProprietyTemplateInputClaimCondition"][];
};
